import { render, staticRenderFns } from "./AprazamentoModal.vue?vue&type=template&id=55c5869f&"
import script from "./AprazamentoModal.vue?vue&type=script&lang=js&"
export * from "./AprazamentoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports